<template>
  <div>
    <div class="clear"></div>
    <!-- Content
    =============================================-->
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Contact Form
          =============================================-->
          <div class="col-12">
            <!-- Contact Info
            =============================================-->

            <div class="row clear-bottommargin">
              <div class="col-lg-5 col-md-5 col-12">
                <img
                  id="welcome_icon"
                  :src="getFullPath('wintershop_welcome.png')"
                  style="width: 75%; margin: 0 0 0 auto;
							display: block;"
                />
              </div>
              <div class="col-lg-6 col-md-6 col-12 adminword">
                <i class="icon-quote-left1" style="font-size: 28px; color: #CCC;"></i>
                ติดตามชุดสวยอัพเดตใหม่ และสอบถามรายละเอียด
                แอดมินของเรายินดีให้บริการ
                <i
                  class="icon-quote-right1"
                  style="font-size: 28px; color: #CCC;"
                ></i>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <!-- <i class="icon-phone3"></i> -->
                      <img :src="getFullPath('line_draw.png')" />
                    </a>
                  </div>
                  <h3>
                    Line
                    <span class="subtitle">@CHERTAM1991</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="https://facebook.com/Chertam1991">
                      <img :src="getFullPath('facebook_draw.png')" />
                    </a>
                  </div>
                  <h3>
                    Facebook
                    <span class="subtitle">facebook.com/Chertam1991</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="https://instagram.com/CHERTAM1991">
                      <img :src="getFullPath('instagram_draw.png')" />
                    </a>
                  </div>
                  <h3>
                    Follow on instragram
                    <span class="subtitle">Instagram.com/CHERTAM1991</span>
                  </h3>
                </div>
              </div>
            </div>
            <!-- Contact Info End -->
          </div>
          <!-- Contact Form End -->
        </div>

        <div class="container clearfix">
          <div class="fancy-title title-dotted-border" style="margin-top: 20px;">
            <h3> สาขาใหญ่ (หน้าร้าน) </h3>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-lg-5 col-md-5 col-12" style="font-size: 16px; text-align:left;">
                <u>เปิดบริการ</u>
                <br /> 09.00-18.00 น. 
                <br />จองออนไลน์ 24 ชม 
                <br />โทร. 0944015666
                <br />
                <!-- <u>Google Map</u> -->
                <br />
                <!-- <a
                  href="https://g.page/wintershopthailand?share"
                >https://g.page/wintershopthailand?share</a> -->
              </div>
              <div class="col-lg-7 col-md-7 col-12">
                <u>รูปแผนที่</u>
                <img :src="getFullPath('LatProw.jpg')" width="100%" />
              </div>
            </div>
          </div>
        </div>

   
        <!-- Google Map
        =============================================-->
        <!-- <div class="col-12 col_last">

							<section id="google-map" class="gmap" style="height: 410px;">
							
							</section>
	
        </div>-->
        <!-- Google Map End -->
      </div>
      <div class="clear"></div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile"
    };
  },
  methods: {
    welcomeMessage() {}
  },
  components: {}
};
</script>
 
<style >
.toggle {
  text-align: left;
}
.togglec {
  text-align: left;
}
.subtitle{
  font-size: 0.7rem;
}

.adminword {
  font-family: Mitr;
  font-size: 28px;
  text-align: left;
  font-size: bold;
  padding: 70px 10px;
  font-weight: bold;
}
@media only screen and (max-width: 578px) {
  #welcome_icon {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>